import { render, staticRenderFns } from "./Nutrients.vue?vue&type=template&id=b7ae3db8&scoped=true"
import script from "./Nutrients.vue?vue&type=script&lang=js"
export * from "./Nutrients.vue?vue&type=script&lang=js"
import style0 from "./Nutrients.vue?vue&type=style&index=0&id=b7ae3db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ae3db8",
  null
  
)

export default component.exports